export default __webpack_public_path__ + "static/media/wagmi-frens.033c8f43.jpeg";